import React from 'react'
import { NavLink } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import NLE from './assets/NLE.png'
import perm from './assets/perm.png'
import middle from './assets/middle.jpg'
import rootl from './assets/rootl.jpg'
import loopLL from './assets/loopLL.jpg'
import lvbt from './assets/lvbt.png'
import stkq from './assets/stkq.png'
import egg from './assets/egg.jpg'
import lis from './assets/lis.png'
import fn from './assets/fn.png'
import bsn from './assets/bsn.png'
import cnb from './assets/cnb.webp'
import tsa from './assets/tsa.png'
import node from './assets/node.jpeg'
const Ind = () => {
    return (
        <div>
               <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={lis}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Longest Increasing Subsequence</p>
      <NavLink to='/category/Samsung Interview question 1'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={NLE} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Next larger element</p>
      <NavLink to='/category/Samsung Interview question 2'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={perm} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Permutations of a given string</p>
        <NavLink to='/category/Samsung Interview question 3'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={fn} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Next greater number set digits</p>
      <NavLink to='/category/Samsung Interview question 4'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={middle} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Finding middle element in a linked list</p>
      <NavLink to='/category/Samsung Interview question 5'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={rootl} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Root to leaf path sum</p>
      <NavLink to='/category/Samsung Interview question 6'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={loopLL} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Detect Loop in linked list</p>
        <NavLink to='/category/Samsung Interview question 7'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={lvbt} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Left View of Binary Tree</p>
      <NavLink to='/category/Samsung Interview question 8'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={stkq} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Implement Queue using Linked List</p>
      <NavLink to='/category/Samsung Interview question 9'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={egg} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Egg Dropping Puzzle</p>
      <NavLink to='/category/Samsung Interview question 10'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={bsn} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Total number of possible Binary Search Trees with n keys</p>
        <NavLink to='/category/Samsung Interview question 11'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={cnb} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Count number of bits to be flipped to convert A to B</p>
      <NavLink to='/category/Samsung Interview question 12'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={tsa} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Implement two stacks in an array</p>
      <NavLink to='/category/Samsung Interview question 13'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  <div class="card 4">
    <div class="card_image">
      <img src={node} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'0.8rem'}}>Given only a pointer/reference to a node to be deleted in a singly linked list, how do you delete it?</p>
      <NavLink to='/category/Samsung Interview question 14'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
        </div>
    )
}

export default Ind
